import React from 'react';
import styles from './CreateCycle.module.scss';
import { useNavigate } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';
import Form from '../../../../Common/Form/Form';
import CreateTeamForm from './CreateCycleForm/CreateCycleForm';
import APIClient from '../../../../../../util/APIClient';
import FormAlert from '../../../../Common/FormAlert/FormAlert';

export default function CreateCycle() {
  const navigate = useNavigate();
  const [formAlert, setFormAlert] = React.useState(null);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [hasSubmitted, setHasSubmitted] = React.useState(false);

  async function onSubmit(data) {
    setIsSubmitting(true);
    const cycle = {
      label: data.label,
      isCurrent: data.isCurrent,
    };

    try {
      const response = await APIClient.post('/administrator/cycles', cycle);
      setHasSubmitted(true);
      setFormAlert({
        severity: 'success',
        title: 'Cycle created successfully!',
        message:
          'Your cycle has been created successfully. You will be redirected shortly.',
      });
      setTimeout(() => {
        navigate(`/administrator/organisation/cycles/${response.data.id}`);
      }, 3000);
    } catch {
      setFormAlert({
        severity: 'error',
        title: 'Could not create cycle!',
        message:
          'Something went wrong during cycle creation. Please contact the administrator for further support.',
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className={styles.createCycle}>
      <h1>Create a new cycle</h1>
      <p className={styles.description}>
        Create a new cycle using the form below.
      </p>
      <Form onSubmit={(data) => onSubmit(data)}>
        <CreateTeamForm />
        <div className={styles.formControls}>
          <LoadingButton
            variant="contained"
            type="submit"
            loading={isSubmitting}
            disabled={hasSubmitted}
            fullWidth
          >
            <span>Create</span>
          </LoadingButton>
        </div>
        {formAlert && <FormAlert alert={formAlert} />}
      </Form>
    </div>
  );
}
